export default __webpack_public_path__ + "static/0027-82860daeb1fd867a6e1e6b11edfbbd6c.png";